
/*
 * Mr. Räder – Fahrzeughervorhebung
 *
 * Reihenfolge:
 * 1. Fahrzeugverwendungsliste mit Ausklapppfeil
 * 2. Grüne Fahrzeugbestätigung (immer sichtbar)
 * 3. Fahrzeugtabelle (nur ausgeklappt)
 */

(() => {
  'use strict';

  const STORAGE_KEY = 'strix-car-model-selection';

  function normalize(value) {
    return String(value ?? '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLocaleLowerCase('de-DE');
  }

  function readSelection() {
    try {
      const value = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || 'null'
      );

      if (
        !value ||
        !['brand', 'model', 'type'].every(
          key =>
            typeof value[key] === 'string' &&
            value[key].trim()
        )
      ) {
        return null;
      }

      return value;
    } catch (error) {
      return null;
    }
  }

  function createConfirmation(selection) {
    const note = document.createElement('div');
    note.className = 'strix-selected-vehicle-note';

    const content = document.createElement('div');
    content.className = 'strix-selected-vehicle-content';

    const title = document.createElement('div');
    title.className = 'strix-selected-vehicle-title';

    title.textContent =
      'Ihr ausgewähltes Fahrzeug: ' +
      [
        selection.brand,
        selection.model,
        selection.type
      ].join(' · ');

    const hint = document.createElement('div');
    hint.className = 'strix-selected-vehicle-hint';

    hint.textContent =
      'Bitte beachten Sie mögliche Einschränkungen je nach individuellem Fahrzeugtyp. Bei Unsicherheit nutzen Sie unsere Passgenauigkeitsprüfung.';

    content.appendChild(title);
    content.appendChild(hint);
    note.appendChild(content);

    return note;
  }

  function highlightSelectedVehicle() {
    const selection = readSelection();

    if (!selection) return;

    document
      .querySelectorAll('[id^="VehicleList-"]')
      .forEach(container => {

        const vehicles = Array.from(
          container.querySelectorAll(
            '[data-vehicle-brand]' +
            '[data-vehicle-model]' +
            '[data-vehicle-type]'
          )
        );

        const matches = vehicles.filter(vehicle =>
          ['brand', 'model', 'type'].every(key => {
            const attribute =
              'vehicle' +
              key.charAt(0).toUpperCase() +
              key.slice(1);

            return normalize(vehicle.dataset[attribute]) ===
              normalize(selection[key]);
          })
        );

        if (!matches.length) return;

        // Passende Fahrzeuge hellblau markieren
        matches.forEach(vehicle => {
          vehicle.classList.add('is-selected-vehicle');
        });

        const details = container.closest('details');

        if (!details) return;

        const summary = details.querySelector('summary');

        if (!summary) return;

        // Vorhandene Bestätigung wiederverwenden
        let note = details.parentElement.querySelector(
          ':scope > .strix-selected-vehicle-note'
        );

        if (!note) {
          note = details.querySelector(
            '.strix-selected-vehicle-note'
          );
        }

        if (!note) {
          note = createConfirmation(selection);
        }

        /*
         * Bestätigung je nach Zustand positionieren.
         *
         * Geschlossen:
         *   Überschrift -> grüner Hinweis
         *
         * Geöffnet:
         *   Überschrift -> grüner Hinweis -> Tabelle
         */

        const updatePosition = () => {
          const content = details.querySelector(
            '.accordion__content'
          );

          if (details.open && content) {
            content.insertAdjacentElement(
              'beforebegin',
              note
            );
          } else {
            details.insertAdjacentElement(
              'afterend',
              note
            );
          }
        };

        details.addEventListener(
          'toggle',
          updatePosition
        );

        updatePosition();

        // Passende Karte im mobilen Slider anzeigen
        const card = matches.find(vehicle =>
          vehicle.classList.contains('strix-vehicle-card')
        );

        const slide = card?.closest('.swiper-slide');
        const swiperElement = slide?.closest('.swiper');

        if (slide && swiperElement) {
          const moveToCard = () => {
            const swiper = swiperElement.swiper;

            if (!swiper || swiper.destroyed) {
              return false;
            }

            const index = Array.from(
              slide.parentElement.children
            ).indexOf(slide);

            if (index < 0) return false;

            swiper.slideTo(index, 0);
            return true;
          };

          let attempts = 0;
          let timer = null;

          const tryMove = () => {
            attempts++;

            if (
              moveToCard() ||
              attempts >= 20 ||
              !swiperElement.isConnected
            ) {
              if (timer !== null) {
                clearInterval(timer);
                timer = null;
              }
            }
          };

          details.addEventListener('toggle', () => {
            if (details.open) {
              tryMove();

              if (!swiperElement.swiper) {
                timer = setInterval(tryMove, 150);
              }
            } else if (timer !== null) {
              clearInterval(timer);
              timer = null;
            }
          });
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      highlightSelectedVehicle,
      { once: true }
    );
  } else {
    highlightSelectedVehicle();
  }
})();
